import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {  ListTableComponent  } from '@ppl/ui';
import { ReferralDataService } from '../../../../services/referral-data.service';
import { SectionsService } from '../../../../services/sections.service';
import { UserService } from '../../../../services/user.service';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { ParticipantLeadsListComponent } from '../../../participant-leads-list/participant-leads-list.component';
import { BillingFilterComponent } from '../../billing-filter/billing-filter.component';

@Component({
  selector: 'ppl-claims-list',
  standalone: true,
  imports: [ListTableComponent, BillingFilterComponent],
  templateUrl: './claims-list.component.html',
  styleUrl: './claims-list.component.css',
})
export class ClaimsListComponent extends ParticipantLeadsListComponent {
  showTable = false;
  override pageId = PAGE_CONSTANTS.CLAIMS_GRID_PAGE;

  constructor(
    router: Router,
    sectionService: SectionsService,
    referralDataService: ReferralDataService,
    sharedDataService: SharedDataService,
    userService: UserService,
    authUtility: AuthorizationUtility,
    allowListStore: AllowListAuthStore
  ) {
    super(
      router,
      sectionService,
      referralDataService,
      sharedDataService,
      userService,
      authUtility,
      allowListStore
    );
  }

  fields = [
    { field: 'Timeframe', show: true, default: '30 days' },
    { field: 'status', show: true },
    { field: 'batchId', show: true },
    { field: 'fileName', show: true },
    { field: 'consumerPplId', show: true },
    { field: 'mcoId', show: true },
    { field: 'medicaidId', show: true },
    { field: 'serviceDate', show: true },
    { field: 'payerName', show: true },
    { field: 'pmpm', show: true },
  ];

  onSearch(event: any) {
    console.log('EVent----', event);
    this.showTable = true;
  }
}
